import React from 'react'
import {KTIcon} from '../../_metronic/helpers'
import {useThemeMode} from '../../_metronic/partials'

interface IProps {
  type?: 'button' | 'submit'
  onClick: (...args: any[]) => void
  className?: string
  iconName?: string
  iconClassName?: string
  disabled?: boolean
  loading?: boolean
  tooltip?: string
  children: React.ReactNode
}

const PrimaryOutlineButton = ({
  onClick,
  type = 'button',
  className = '',
  iconName,
  iconClassName = '',
  disabled = false,
  loading = false,
  tooltip = '',
  children,
}: IProps) => {
  const {mode} = useThemeMode()
  return (
    <button
      type={type}
      onClick={loading ? undefined : onClick}
      disabled={disabled || loading}
      className={`btn btn-sm bg-${
        mode === 'dark' ? 'secondary' : 'white'
      } btn-outline border-primary text-primary btn-active-light-primary ${className} d-flex align-items-center`}
      data-bs-toggle='tooltip'
      title={tooltip || ''}
    >
      {iconName && <KTIcon iconName={iconName} className={`fs-3 text-primary ${iconClassName}`} />}
      {children}
    </button>
  )
}

export {PrimaryOutlineButton}
